import * as firebase from 'firebase';
//import 'firebase/analytics';

import appConfig from '../app.config';

export const initialize = () => {
  firebase.initializeApp(appConfig.web.config.firebase);
  firebase.analytics();
};
